import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import Category from '../../entities/category';
import Task from '../../entities/task';
import TemplateTask from '../../entities/templateTask';

/*
 * Delete/nullify anywhere this category is used in other entities
 *
 * @param {Category} category
 */
export function deleteCategory(category: Category, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = category.id;
    }
    /* Simple delete usages */
        
    store.getState().tasks
        .getMappingFor('categoryId', category.id)
        .filter(taskTemp => taskTemp.status !== 'D')
        .forEach(taskTemp => {
            const _task = taskTemp.clone();
            _task.status =  'U';
            _task.addedOn = newHRTimestamp();
            _task.importSource = targetImportSource;
            _task.importId = mergeId;

            _task.categories = _task.categories?.filter(id => id !== category.id) || [];
            store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
        });

    store.getState().templateTasks
        .getMappingFor('categoryId', category.id)
        .filter(templateTaskTemp => templateTaskTemp.status !== 'D')
        .forEach(templateTaskTemp => {
            const _templateTask = templateTaskTemp.clone();
            _templateTask.status =  'U';
            _templateTask.addedOn = newHRTimestamp();
            _templateTask.importSource = targetImportSource;
            _templateTask.importId = mergeId;

            _templateTask.categories = _templateTask.categories?.filter(id => id !== category.id) || [];
            store.dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask));
        });

    /* Remove the actual category */
    category.status = 'D';
    category.addedOn = newHRTimestamp();
    category.addedBy = getCurrentUserId();
    category.importSource = targetImportSource;
    category.importId = mergeId;
    store.dispatch(Actions.CategoryActions.removeCategoryQueue(category));
    
}

/*
 * Replace anywhere this category is used in other entities.
 *
 * @param {Category} category
 * @param {Category} replaceWith
 * @return {Category} - Category will have refs stripped away
 */
export function replaceCategory(category: Category, replaceWith: Category, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = category.id;
    }
    /* Simple replace usages */
        
    store.getState().tasks
        .getMappingFor('categoryId', category.id)
        .filter(taskTemp => taskTemp.status !== 'D')
        .forEach(taskTemp => {
            const _task = taskTemp.clone();
            _task.status =  'U';
            _task.addedOn = newHRTimestamp();
            _task.importSource = targetImportSource;
            _task.importId = mergeId;

            _task.categories = _task.categories?.map(id => (id === category.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
        });

    store.getState().templateTasks
        .getMappingFor('categoryId', category.id)
        .filter(templateTaskTemp => templateTaskTemp.status !== 'D')
        .forEach(templateTaskTemp => {
            const _templateTask = templateTaskTemp.clone();
            _templateTask.status =  'U';
            _templateTask.addedOn = newHRTimestamp();
            _templateTask.importSource = targetImportSource;
            _templateTask.importId = mergeId;

            _templateTask.categories = _templateTask.categories?.map(id => (id === category.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask));
        });

    return category;
}

/*
 * Determine the impact of deleting this category from other entities
 *
 * @param {Category} category
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactCategory(category: Category) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Simple delete usages */
        
    const taskCategoriesImpact = state.tasks
          .getMappingFor('categoryId', category.id)
          .filter(task => task.status !== 'D');

    taskCategoriesImpact.forEach(() => impacts.push('tasks'));

    const templateTaskCategoriesImpact = state.templateTasks
          .getMappingFor('categoryId', category.id)
          .filter(templateTask => templateTask.status !== 'D');

    templateTaskCategoriesImpact.forEach(() => impacts.push('templateTasks'));

    return util.countDistinct(impacts);
}